"use strict";

(function () {
  'use strict';

  angular.module('lr.components', ['lr.Graphs', 'infinite-scroll', 'lr.Loader', 'lr.Map', 'lr.Notifier', 'lr.Timeline']);
})();